import {
  checkWordAgainstAnswer as checkWord,
  formatWordForCheckingAgainstAnswer as formatWord
} from "seneca-common/utils/functions";

import { Answer, Content, Score, TestableWord } from "../types";

export function markAnswer(content: Content, answer: Answer): Score {
  const wordsScore = content.words.reduce(
    (words: any, entry: string | TestableWord) => {
      if (typeof entry !== "string" && entry.testing) {
        const { word, otherPermittedWords = [] } = entry;
        const wordsToCheck = [word, ...otherPermittedWords];

        if (!answer || !answer.words || !answer.words[word]) {
          words[word] = false;
        } else {
          words[word] = wordsToCheck.some(w =>
            checkWord(w, answer.words[word], content.noTolerance)
          );
        }
      }

      return words;
    },
    {}
  );
  return {
    words: wordsScore,
    score:
      Object.values(wordsScore).filter(res => res).length /
      Object.values(wordsScore).length
  };
}

export function generateInitialUserAnswer() {
  return {
    words: {}
  };
}

export { checkWord, formatWord };
